import { LOGOUT } from '../actions/login';
import { SEARCH_COMPLETE_POLICY, SEARCH_ERROR_POLICY, START_SEARCH_POLICY, START_SEARCH_ISSUED } from '../actions/policy';

const initialState = {
  loading: false,
  condition: {},
  data: [],
  issuedCondition: {}
};
const reducer = (state = initialState, action) => {
  const { type } = action;
  switch (type) {
    case START_SEARCH_POLICY:
      let condition = action.payload;
      condition = Object.keys(condition).reduce((result, key) => {
        if (condition?.[key]) return Object.assign({}, result, { [key]: condition?.[key] });
        return result;
      }, {});
      return { ...initialState, condition, loading: true };
    case START_SEARCH_ISSUED:
      let issuedCondition = action.payload;
      issuedCondition = Object.keys(issuedCondition).reduce((result, key) => {
        if (issuedCondition?.[key]) return Object.assign({}, result, { [key]: issuedCondition?.[key] });
        return result;
      }, {});
      return { ...initialState, issuedCondition, loading: true };
    case SEARCH_COMPLETE_POLICY:
      return { ...state, data: [...action.payload], loading: false };

    case SEARCH_ERROR_POLICY:
      return { ...state, loading: false };

    case LOGOUT:
      return { ...initialState };

    default:
      return { ...state };
  }
};
export default reducer;